module.exports = "https://files.cnvos.si/static/images/sociala.png?b2b965b2f448dffdd781fa74bebeed6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/sociala.png
// module id = 124
// module chunks = 1 2